{
  "method": "docs/plans/houses.md, \"The painting per block side\"; src/world/fabric/painted/roofReading.ts READING",
  "between": {
    "main": 0.134,
    "other": 0.195,
    "lastage": 0.171
  },
  "blocks": {
    "quay-kattengat-north-3:right:1": {
      "tile": 0.852,
      "reading": 0.83,
      "spread": 0.088,
      "pixels": 320
    },
    "quay-nieuwezijds-voorburgwal:left:1": {
      "tile": 0.825,
      "reading": 0.807,
      "spread": 0.085,
      "pixels": 1461
    },
    "quay-rokin-north-west:right:0": {
      "tile": 0.878,
      "reading": 0.851,
      "spread": 0.063,
      "pixels": 274
    },
    "street-dirk-van-hasseltssteeg/drawn1:left:0": {
      "tile": 0.988,
      "reading": 0.942,
      "spread": 0.05,
      "pixels": 91
    },
    "street-dirk-van-hasseltssteeg:left:0": {
      "tile": 0.78,
      "reading": 0.77,
      "spread": 0.093,
      "pixels": 976
    },
    "street-gouwenaarssteeg:right:0": {
      "tile": 0.853,
      "reading": 0.83,
      "spread": 0.074,
      "pixels": 377
    },
    "street-halsteeg:right:0": {
      "tile": 0.787,
      "reading": 0.775,
      "spread": 0.087,
      "pixels": 399
    },
    "street-nieuwendijk:left:5": {
      "tile": 0.784,
      "reading": 0.773,
      "spread": 0.058,
      "pixels": 1937
    }
  },
  "sides": {
    "quay-kattengat-north-3:right": {
      "tile": 0.695,
      "reading": 0.699,
      "spread": 0.093,
      "pixels": 1103
    },
    "street-nieuwendijk:left": {
      "tile": 0.676,
      "reading": 0.683,
      "spread": 0.041,
      "pixels": 4608
    },
    "street-nieuwendijk:right": {
      "tile": 0.712,
      "reading": 0.713,
      "spread": 0.025,
      "pixels": 13424
    },
    "street-zeedijk:right": {
      "tile": 0.707,
      "reading": 0.709,
      "spread": 0.064,
      "pixels": 3618
    }
  },
  "seen": {
    "backhouse:quay-kattengat-north-3:right:10": 29,
    "backhouse:quay-kattengat-north-3:right:11": 31,
    "backhouse:quay-kattengat-north-3:right:14": 39,
    "backhouse:quay-kattengat-north-3:right:15": 27,
    "backhouse:quay-kattengat-north-3:right:17": 14,
    "backhouse:quay-kattengat-north-3:right:18": 31,
    "backhouse:quay-kattengat-north-3:right:19": 48,
    "backhouse:quay-kattengat-north-3:right:2": 21,
    "backhouse:quay-kattengat-north-3:right:3": 26,
    "backhouse:quay-kattengat-north-3:right:5": 30,
    "backhouse:quay-kattengat-north-3:right:6": 36,
    "backhouse:quay-kattengat-north-3:right:7": 32,
    "backhouse:quay-kattengat-north-3:right:8": 47,
    "backhouse:quay-kattengat-north-3:right:9": 29,
    "backhouse:quay-nieuwezijds-voorburgwal:left:1": 119,
    "backhouse:quay-nieuwezijds-voorburgwal:left:2": 41,
    "backhouse:quay-nieuwezijds-voorburgwal:left:4": 20,
    "backhouse:quay-nieuwezijds-voorburgwal:left:5": 56,
    "backhouse:quay-nieuwezijds-voorburgwal:left:8": 80,
    "backhouse:quay-nieuwezijds-voorburgwal:left:9": 65,
    "backhouse:quay-rokin-north-west:right:1": 11,
    "backhouse:quay-rokin-north-west:right:2": 35,
    "backhouse:quay-rokin-north-west:right:3": 31,
    "backhouse:street-dirk-van-hasseltssteeg/drawn1:left:1": 60,
    "backhouse:street-dirk-van-hasseltssteeg/drawn1:left:12": 31,
    "backhouse:street-dirk-van-hasseltssteeg:left:0": 5,
    "backhouse:street-dirk-van-hasseltssteeg:left:16": 45,
    "backhouse:street-dirk-van-hasseltssteeg:left:17": 68,
    "backhouse:street-dirk-van-hasseltssteeg:left:18": 20,
    "backhouse:street-dirk-van-hasseltssteeg:left:4": 37,
    "backhouse:street-dirk-van-hasseltssteeg:left:5": 11,
    "backhouse:street-dirk-van-hasseltssteeg:left:6": 21,
    "backhouse:street-dirk-van-hasseltssteeg:left:7": 54,
    "backhouse:street-gouwenaarssteeg:right:0": 15,
    "backhouse:street-gouwenaarssteeg:right:4": 16,
    "backhouse:street-nieuwendijk:left:10": 17,
    "backhouse:street-nieuwendijk:left:11": 36,
    "backhouse:street-nieuwendijk:left:12": 29,
    "backhouse:street-nieuwendijk:left:13": 7,
    "backhouse:street-nieuwendijk:left:18": 25,
    "backhouse:street-nieuwendijk:left:19": 6,
    "backhouse:street-nieuwendijk:left:20": 37,
    "backhouse:street-nieuwendijk:left:21": 78,
    "backhouse:street-nieuwendijk:left:22": 49,
    "backhouse:street-nieuwendijk:left:23": 33,
    "backhouse:street-nieuwendijk:left:24": 45,
    "backhouse:street-nieuwendijk:left:25": 47,
    "backhouse:street-nieuwendijk:left:26": 11,
    "backhouse:street-nieuwendijk:left:27": 25,
    "backhouse:street-nieuwendijk:left:31": 11,
    "backhouse:street-nieuwendijk:left:32": 51,
    "backhouse:street-nieuwendijk:left:33": 34,
    "backhouse:street-nieuwendijk:left:34": 68,
    "backhouse:street-nieuwendijk:left:35": 20,
    "backhouse:street-nieuwendijk:left:36": 8,
    "backhouse:street-nieuwendijk:left:37": 60,
    "backhouse:street-nieuwendijk:left:40": 60,
    "backhouse:street-nieuwendijk:left:44": 33,
    "backhouse:street-nieuwendijk:left:45": 41,
    "backhouse:street-nieuwendijk:left:46": 48,
    "backhouse:street-nieuwendijk:left:49": 76,
    "backhouse:street-nieuwendijk:left:5": 54,
    "backhouse:street-nieuwendijk:left:50": 22,
    "backhouse:street-nieuwendijk:left:51": 76,
    "backhouse:street-nieuwendijk:left:53": 31,
    "backhouse:street-nieuwendijk:left:54": 20,
    "backhouse:street-nieuwendijk:left:57": 60,
    "backhouse:street-nieuwendijk:left:58": 61,
    "backhouse:street-nieuwendijk:left:59": 43,
    "backhouse:street-nieuwendijk:left:66": 61,
    "backhouse:street-nieuwendijk:left:67": 47,
    "backhouse:street-nieuwendijk:left:69": 58,
    "backhouse:street-nieuwendijk:left:70": 38,
    "backhouse:street-nieuwendijk:left:71": 64,
    "backhouse:street-nieuwendijk:left:72": 30,
    "backhouse:street-nieuwendijk:left:73": 53,
    "backhouse:street-nieuwendijk:left:74": 26,
    "backhouse:street-nieuwendijk:left:78": 37,
    "backhouse:street-nieuwendijk:left:79": 53,
    "backhouse:street-nieuwendijk:left:80": 30,
    "backhouse:street-nieuwendijk:left:9": 28,
    "backhouse:street-nieuwendijk:right:1": 51,
    "backhouse:street-nieuwendijk:right:10": 37,
    "backhouse:street-nieuwendijk:right:2": 45,
    "backhouse:street-nieuwendijk:right:3": 45,
    "backhouse:street-nieuwendijk:right:4": 34,
    "backhouse:street-nieuwendijk:right:5": 58,
    "backhouse:street-nieuwendijk:right:6": 55,
    "backhouse:street-nieuwendijk:right:7": 8,
    "backhouse:street-nieuwendijk:right:8": 14,
    "backhouse:street-zeedijk:right:13": 17,
    "backhouse:street-zeedijk:right:14": 48,
    "backhouse:street-zeedijk:right:15": 1,
    "backhouse:street-zeedijk:right:16": 43,
    "backhouse:street-zeedijk:right:17": 19,
    "backhouse:street-zeedijk:right:18": 33,
    "backhouse:street-zeedijk:right:22": 9,
    "backhouse:street-zeedijk:right:24": 49,
    "backhouse:street-zeedijk:right:25": 6,
    "backhouse:street-zeedijk:right:26": 69,
    "backhouse:street-zeedijk:right:32": 42,
    "backhouse:street-zeedijk:right:33": 54,
    "backhouse:street-zeedijk:right:39": 10,
    "backhouse:street-zeedijk:right:40": 44,
    "backhouse:street-zeedijk:right:41": 44,
    "backhouse:street-zeedijk:right:42": 44,
    "backhouse:street-zeedijk:right:43": 41,
    "backhouse:street-zeedijk:right:44": 63,
    "backhouse:street-zeedijk:right:45": 50,
    "backhouse:street-zeedijk:right:46": 98,
    "backhouse:street-zeedijk:right:47": 39,
    "backhouse:street-zeedijk:right:9": 29,
    "house:quay-kattengat-north-3:right:0": 74,
    "house:quay-kattengat-north-3:right:1": 34,
    "house:quay-kattengat-north-3:right:10": 40,
    "house:quay-kattengat-north-3:right:11": 48,
    "house:quay-kattengat-north-3:right:12": 56,
    "house:quay-kattengat-north-3:right:13": 29,
    "house:quay-kattengat-north-3:right:14": 51,
    "house:quay-kattengat-north-3:right:15": 54,
    "house:quay-kattengat-north-3:right:16": 64,
    "house:quay-kattengat-north-3:right:17": 31,
    "house:quay-kattengat-north-3:right:18": 51,
    "house:quay-kattengat-north-3:right:19": 50,
    "house:quay-kattengat-north-3:right:2": 30,
    "house:quay-kattengat-north-3:right:3": 69,
    "house:quay-kattengat-north-3:right:4": 18,
    "house:quay-kattengat-north-3:right:5": 25,
    "house:quay-kattengat-north-3:right:6": 57,
    "house:quay-kattengat-north-3:right:7": 68,
    "house:quay-kattengat-north-3:right:8": 70,
    "house:quay-kattengat-north-3:right:9": 64,
    "house:quay-nieuwezijds-voorburgwal:left:0": 117,
    "house:quay-nieuwezijds-voorburgwal:left:1": 72,
    "house:quay-nieuwezijds-voorburgwal:left:10": 73,
    "house:quay-nieuwezijds-voorburgwal:left:11": 57,
    "house:quay-nieuwezijds-voorburgwal:left:12": 74,
    "house:quay-nieuwezijds-voorburgwal:left:13": 80,
    "house:quay-nieuwezijds-voorburgwal:left:14": 109,
    "house:quay-nieuwezijds-voorburgwal:left:15": 38,
    "house:quay-nieuwezijds-voorburgwal:left:2": 42,
    "house:quay-nieuwezijds-voorburgwal:left:3": 67,
    "house:quay-nieuwezijds-voorburgwal:left:4": 27,
    "house:quay-nieuwezijds-voorburgwal:left:5": 72,
    "house:quay-nieuwezijds-voorburgwal:left:6": 58,
    "house:quay-nieuwezijds-voorburgwal:left:7": 57,
    "house:quay-nieuwezijds-voorburgwal:left:8": 74,
    "house:quay-nieuwezijds-voorburgwal:left:9": 63,
    "house:quay-rokin-north-west:right:0": 51,
    "house:quay-rokin-north-west:right:1": 37,
    "house:quay-rokin-north-west:right:2": 33,
    "house:quay-rokin-north-west:right:3": 28,
    "house:quay-rokin-north-west:right:4": 48,
    "house:street-dirk-van-hasseltssteeg:left:0": 28,
    "house:street-dirk-van-hasseltssteeg:left:1": 36,
    "house:street-dirk-van-hasseltssteeg:left:10": 13,
    "house:street-dirk-van-hasseltssteeg:left:11": 26,
    "house:street-dirk-van-hasseltssteeg:left:12": 25,
    "house:street-dirk-van-hasseltssteeg:left:13": 36,
    "house:street-dirk-van-hasseltssteeg:left:14": 34,
    "house:street-dirk-van-hasseltssteeg:left:15": 39,
    "house:street-dirk-van-hasseltssteeg:left:16": 28,
    "house:street-dirk-van-hasseltssteeg:left:17": 32,
    "house:street-dirk-van-hasseltssteeg:left:18": 17,
    "house:street-dirk-van-hasseltssteeg:left:19": 48,
    "house:street-dirk-van-hasseltssteeg:left:2": 29,
    "house:street-dirk-van-hasseltssteeg:left:20": 30,
    "house:street-dirk-van-hasseltssteeg:left:3": 62,
    "house:street-dirk-van-hasseltssteeg:left:4": 28,
    "house:street-dirk-van-hasseltssteeg:left:5": 60,
    "house:street-dirk-van-hasseltssteeg:left:6": 11,
    "house:street-dirk-van-hasseltssteeg:left:7": 59,
    "house:street-dirk-van-hasseltssteeg:left:8": 28,
    "house:street-dirk-van-hasseltssteeg:left:9": 46,
    "house:street-gouwenaarssteeg:right:0": 53,
    "house:street-gouwenaarssteeg:right:1": 21,
    "house:street-gouwenaarssteeg:right:2": 62,
    "house:street-gouwenaarssteeg:right:3": 53,
    "house:street-gouwenaarssteeg:right:4": 57,
    "house:street-gouwenaarssteeg:right:5": 43,
    "house:street-gouwenaarssteeg:right:6": 25,
    "house:street-gouwenaarssteeg:right:7": 32,
    "house:street-halsteeg:right:0": 36,
    "house:street-halsteeg:right:1": 17,
    "house:street-halsteeg:right:10": 41,
    "house:street-halsteeg:right:11": 9,
    "house:street-halsteeg:right:12": 31,
    "house:street-halsteeg:right:13": 21,
    "house:street-halsteeg:right:14": 15,
    "house:street-halsteeg:right:15": 7,
    "house:street-halsteeg:right:2": 30,
    "house:street-halsteeg:right:3": 18,
    "house:street-halsteeg:right:4": 40,
    "house:street-halsteeg:right:5": 13,
    "house:street-halsteeg:right:6": 21,
    "house:street-halsteeg:right:7": 20,
    "house:street-halsteeg:right:8": 37,
    "house:street-halsteeg:right:9": 43,
    "house:street-nieuwendijk:left:0": 41,
    "house:street-nieuwendijk:left:1": 33,
    "house:street-nieuwendijk:left:10": 48,
    "house:street-nieuwendijk:left:11": 31,
    "house:street-nieuwendijk:left:12": 48,
    "house:street-nieuwendijk:left:13": 5,
    "house:street-nieuwendijk:left:14": 73,
    "house:street-nieuwendijk:left:15": 91,
    "house:street-nieuwendijk:left:16": 50,
    "house:street-nieuwendijk:left:17": 46,
    "house:street-nieuwendijk:left:18": 20,
    "house:street-nieuwendijk:left:19": 36,
    "house:street-nieuwendijk:left:2": 38,
    "house:street-nieuwendijk:left:20": 23,
    "house:street-nieuwendijk:left:21": 71,
    "house:street-nieuwendijk:left:22": 45,
    "house:street-nieuwendijk:left:23": 56,
    "house:street-nieuwendijk:left:24": 38,
    "house:street-nieuwendijk:left:25": 96,
    "house:street-nieuwendijk:left:26": 21,
    "house:street-nieuwendijk:left:27": 18,
    "house:street-nieuwendijk:left:28": 102,
    "house:street-nieuwendijk:left:29": 78,
    "house:street-nieuwendijk:left:3": 71,
    "house:street-nieuwendijk:left:30": 87,
    "house:street-nieuwendijk:left:31": 14,
    "house:street-nieuwendijk:left:32": 52,
    "house:street-nieuwendijk:left:33": 83,
    "house:street-nieuwendijk:left:34": 46,
    "house:street-nieuwendijk:left:35": 48,
    "house:street-nieuwendijk:left:36": 57,
    "house:street-nieuwendijk:left:37": 59,
    "house:street-nieuwendijk:left:38": 65,
    "house:street-nieuwendijk:left:39": 36,
    "house:street-nieuwendijk:left:4": 22,
    "house:street-nieuwendijk:left:40": 78,
    "house:street-nieuwendijk:left:41": 53,
    "house:street-nieuwendijk:left:42": 50,
    "house:street-nieuwendijk:left:43": 47,
    "house:street-nieuwendijk:left:44": 52,
    "house:street-nieuwendijk:left:45": 32,
    "house:street-nieuwendijk:left:46": 68,
    "house:street-nieuwendijk:left:47": 19,
    "house:street-nieuwendijk:left:48": 61,
    "house:street-nieuwendijk:left:49": 74,
    "house:street-nieuwendijk:left:5": 19,
    "house:street-nieuwendijk:left:50": 14,
    "house:street-nieuwendijk:left:51": 80,
    "house:street-nieuwendijk:left:52": 128,
    "house:street-nieuwendijk:left:53": 12,
    "house:street-nieuwendijk:left:54": 104,
    "house:street-nieuwendijk:left:55": 14,
    "house:street-nieuwendijk:left:56": 117,
    "house:street-nieuwendijk:left:57": 76,
    "house:street-nieuwendijk:left:58": 73,
    "house:street-nieuwendijk:left:59": 35,
    "house:street-nieuwendijk:left:6": 45,
    "house:street-nieuwendijk:left:60": 70,
    "house:street-nieuwendijk:left:61": 37,
    "house:street-nieuwendijk:left:62": 70,
    "house:street-nieuwendijk:left:63": 57,
    "house:street-nieuwendijk:left:64": 154,
    "house:street-nieuwendijk:left:65": 86,
    "house:street-nieuwendijk:left:66": 64,
    "house:street-nieuwendijk:left:67": 59,
    "house:street-nieuwendijk:left:68": 45,
    "house:street-nieuwendijk:left:69": 60,
    "house:street-nieuwendijk:left:7": 40,
    "house:street-nieuwendijk:left:70": 38,
    "house:street-nieuwendijk:left:71": 117,
    "house:street-nieuwendijk:left:72": 70,
    "house:street-nieuwendijk:left:73": 82,
    "house:street-nieuwendijk:left:74": 45,
    "house:street-nieuwendijk:left:75": 63,
    "house:street-nieuwendijk:left:76": 46,
    "house:street-nieuwendijk:left:77": 58,
    "house:street-nieuwendijk:left:78": 35,
    "house:street-nieuwendijk:left:79": 77,
    "house:street-nieuwendijk:left:8": 38,
    "house:street-nieuwendijk:left:80": 73,
    "house:street-nieuwendijk:left:81": 48,
    "house:street-nieuwendijk:left:82": 55,
    "house:street-nieuwendijk:left:83": 45,
    "house:street-nieuwendijk:left:84": 63,
    "house:street-nieuwendijk:left:9": 4,
    "house:street-nieuwendijk:right:0": 53,
    "house:street-nieuwendijk:right:1": 91,
    "house:street-nieuwendijk:right:10": 42,
    "house:street-nieuwendijk:right:10300": 135,
    "house:street-nieuwendijk:right:10301": 172,
    "house:street-nieuwendijk:right:10302": 124,
    "house:street-nieuwendijk:right:10303": 17,
    "house:street-nieuwendijk:right:10304": 206,
    "house:street-nieuwendijk:right:10305": 157,
    "house:street-nieuwendijk:right:10306": 224,
    "house:street-nieuwendijk:right:10307": 36,
    "house:street-nieuwendijk:right:10308": 142,
    "house:street-nieuwendijk:right:10309": 39,
    "house:street-nieuwendijk:right:10310": 206,
    "house:street-nieuwendijk:right:10311": 113,
    "house:street-nieuwendijk:right:10312": 152,
    "house:street-nieuwendijk:right:10313": 136,
    "house:street-nieuwendijk:right:10314": 105,
    "house:street-nieuwendijk:right:10315": 217,
    "house:street-nieuwendijk:right:10400": 128,
    "house:street-nieuwendijk:right:10401": 249,
    "house:street-nieuwendijk:right:10402": 164,
    "house:street-nieuwendijk:right:10403": 340,
    "house:street-nieuwendijk:right:10405": 250,
    "house:street-nieuwendijk:right:10406": 224,
    "house:street-nieuwendijk:right:10407": 178,
    "house:street-nieuwendijk:right:10408": 272,
    "house:street-nieuwendijk:right:10410": 325,
    "house:street-nieuwendijk:right:10411": 192,
    "house:street-nieuwendijk:right:10412": 246,
    "house:street-nieuwendijk:right:10413": 225,
    "house:street-nieuwendijk:right:10414": 222,
    "house:street-nieuwendijk:right:10415": 191,
    "house:street-nieuwendijk:right:10416": 203,
    "house:street-nieuwendijk:right:10417": 327,
    "house:street-nieuwendijk:right:10418": 71,
    "house:street-nieuwendijk:right:10419": 260,
    "house:street-nieuwendijk:right:10420": 342,
    "house:street-nieuwendijk:right:10421": 158,
    "house:street-nieuwendijk:right:10422": 198,
    "house:street-nieuwendijk:right:10423": 40,
    "house:street-nieuwendijk:right:10424": 408,
    "house:street-nieuwendijk:right:10425": 66,
    "house:street-nieuwendijk:right:10501": 270,
    "house:street-nieuwendijk:right:10502": 183,
    "house:street-nieuwendijk:right:10503": 103,
    "house:street-nieuwendijk:right:10504": 342,
    "house:street-nieuwendijk:right:10505": 75,
    "house:street-nieuwendijk:right:10506": 65,
    "house:street-nieuwendijk:right:10507": 147,
    "house:street-nieuwendijk:right:10508": 218,
    "house:street-nieuwendijk:right:10509": 94,
    "house:street-nieuwendijk:right:10510": 274,
    "house:street-nieuwendijk:right:10511": 221,
    "house:street-nieuwendijk:right:10512": 215,
    "house:street-nieuwendijk:right:10513": 283,
    "house:street-nieuwendijk:right:10600": 185,
    "house:street-nieuwendijk:right:10601": 290,
    "house:street-nieuwendijk:right:10602": 188,
    "house:street-nieuwendijk:right:10603": 126,
    "house:street-nieuwendijk:right:10604": 296,
    "house:street-nieuwendijk:right:10605": 261,
    "house:street-nieuwendijk:right:10606": 230,
    "house:street-nieuwendijk:right:10607": 255,
    "house:street-nieuwendijk:right:10608": 266,
    "house:street-nieuwendijk:right:10609": 224,
    "house:street-nieuwendijk:right:10610": 115,
    "house:street-nieuwendijk:right:10611": 42,
    "house:street-nieuwendijk:right:11": 54,
    "house:street-nieuwendijk:right:2": 54,
    "house:street-nieuwendijk:right:3": 42,
    "house:street-nieuwendijk:right:4": 55,
    "house:street-nieuwendijk:right:5": 71,
    "house:street-nieuwendijk:right:6": 45,
    "house:street-nieuwendijk:right:7": 55,
    "house:street-nieuwendijk:right:8": 41,
    "house:street-nieuwendijk:right:9": 46,
    "house:street-zeedijk:right:0": 43,
    "house:street-zeedijk:right:1": 47,
    "house:street-zeedijk:right:10": 53,
    "house:street-zeedijk:right:11": 29,
    "house:street-zeedijk:right:12": 57,
    "house:street-zeedijk:right:13": 58,
    "house:street-zeedijk:right:14": 43,
    "house:street-zeedijk:right:15": 38,
    "house:street-zeedijk:right:16": 96,
    "house:street-zeedijk:right:17": 62,
    "house:street-zeedijk:right:18": 59,
    "house:street-zeedijk:right:2": 42,
    "house:street-zeedijk:right:21": 42,
    "house:street-zeedijk:right:22": 54,
    "house:street-zeedijk:right:23": 58,
    "house:street-zeedijk:right:24": 34,
    "house:street-zeedijk:right:25": 23,
    "house:street-zeedijk:right:26": 50,
    "house:street-zeedijk:right:27": 76,
    "house:street-zeedijk:right:28": 99,
    "house:street-zeedijk:right:29": 44,
    "house:street-zeedijk:right:3": 38,
    "house:street-zeedijk:right:30": 118,
    "house:street-zeedijk:right:31": 46,
    "house:street-zeedijk:right:32": 98,
    "house:street-zeedijk:right:33": 115,
    "house:street-zeedijk:right:34": 68,
    "house:street-zeedijk:right:35": 94,
    "house:street-zeedijk:right:36": 67,
    "house:street-zeedijk:right:37": 70,
    "house:street-zeedijk:right:38": 109,
    "house:street-zeedijk:right:39": 45,
    "house:street-zeedijk:right:4": 50,
    "house:street-zeedijk:right:40": 35,
    "house:street-zeedijk:right:41": 65,
    "house:street-zeedijk:right:42": 69,
    "house:street-zeedijk:right:43": 56,
    "house:street-zeedijk:right:44": 71,
    "house:street-zeedijk:right:45": 98,
    "house:street-zeedijk:right:46": 73,
    "house:street-zeedijk:right:47": 45,
    "house:street-zeedijk:right:5": 34,
    "house:street-zeedijk:right:6": 44,
    "house:street-zeedijk:right:7": 57,
    "house:street-zeedijk:right:8": 49,
    "house:street-zeedijk:right:9": 45
  }
}
